import { brandOverride } from '../clients/brandOverride';

export const CHALLENGE_DETAILS = [
  {
    label: 'Start date',
    value: brandOverride().startDate,
  },
  {
    label: 'End date',
    value: brandOverride().endDate,
  },
  {
    label: 'Distance',
    value: `${brandOverride().challengeDistance} miles`,
  },
];
